export enum NodeType {
  Folder = 0,
  Blob = 1,
  Document = 2,
  Text = 3
}
